import React from 'react';
import Waiter from "../../controls/Waiter.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import Linkset from "./Linkset.mjs";
import appLib from "../../libs/appLib.mjs";
import { Glob as G } from "../../libs/Glob.mjs";
import "./Links.css";

const filterData = (data, state) => {
	const filtered = {};
	const labels = {};
	Object.entries(data||{}).forEach( ([k,v]) => {
		if ( v.lan && state.wan ) return;
		if ( v.wan && state.lan ) return;
		v.links = (v.links||[]).filter( l => {
			if (l.lan && state.wan) return false;
			if (l.wan && state.lan) return false;
			return true;
		});
		if ( ! v.links.length ) return;
		filtered[k] = v;
		labels[k] = v.label ?? 'link-'+k;
	});
	return { data: filtered, labels: labels, keys: Object.keys(filtered) };
}

const Links = class Links extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('Links');
		const s = {
			lan: G.prop.isLAN,
			wan: ! G.prop.isLAN
		};
		this.state = filterData( appLib.dataCache('links'), s );
		this.state.lan = s.lan;
		this.state.wan = s.wan;
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		setTimeout(this.load);
	}
	async load() {
		this.setState( filterData( await appLib.data('links'), this.state ) );
	}
	render() {
		if ( typeof this.state.data === 'undefined' ) {
			return(
				<div className={"text-center"}>
					<Waiter />
				</div>
			);
		}
		return(
			<div className={"Links"} id={this.uid}>
				{ this.state.keys.map( ( k, i ) => (
					<div key={ i }>
						<h3>
							<TextLabel value={this.state.labels[k]} />:
						</h3>
						<Linkset data={this.state.data[k]} set={k} />
					</div>
				))}
			</div>
		)
	}
}

export default Links;